/**
 * @file Defines the {@link DESKTOP_IDS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * @type {object}
  * @constant
  * @default
  * @property {string}   autospin - Autospin desktop button ID.
  * @property {string}   bet      - Bet desktop button ID.
  * @property {string}   menu     - Menu desktop button ID.
  * @property {string}   paytable - Paytable desktop button ID.
  * @property {string}   sound    - Sound desktop button ID.
  * @property {string}   spin     - Spin desktop button ID.
  */
 const DESKTOP_IDS = {

    'autospin': 'autoPlay',
    'bet':      'betOptions',
    'paytable': 'helpButton',
    'menu':     'menuButton',
    'sound':    'soundButton',
    'spin':     'spinButton'

 }

 export { DESKTOP_IDS }